export default {
    translation: {
        title: "América",
        applications: "Aplicaciones",
        full_text: "Texto completo",
        vehicle: {
            status: "Conduciendo hacia {{direction}} a {{speed}} mph."
        },
        talkie: {
            drivers_nearby_singular: "1 conductor cerca",
            drivers_nearby_plural: "{{count}} conductores cerca"
        },
        settings: {
            save_progress_description:
                "Guarda tu progreso en un disquete para hacer una copia de seguridad o transferir entre computadoras.",
            save_progress_action: "Guardar progreso",
            load_progress_action: "Cargar progreso...",
            display_units: "Unidades de medida",
            imperial: "Imperiales",
            metric: "Métricas",
            start_over_description:
                "Termina tu viaje antes de tiempo. El progreso actual se borrará. Esto no se puede deshacer.",
            start_over_action: "Reiniciar"
        },
        feedback: {
            message: "Mensaje",
            contact_info: "Información de contacto (opcional)",
            send: "Enviar",
            sending: "Enviando..."
        },
        radio: {
            no_reception: "no hay recepción de radio en esta zona",
            low_signal: "señal débil",
            turn_off: "Apagar",
            turn_on: "Encender",
            next_station: "Siguiente estación",
            unmute: "Activar sonido",
            mute: "Silenciar"
        },
        photos: {
            source: "De Mapillary",
            empty: "Mirando alrededor para tomar una foto..."
        },
        news: {
            loading: "Revisando los titulares locales...",
            nothing_found: "Nada encontrado."
        },
        metrics: {
            duration_title: "Tiempo de conducción",
            duration_value: "{{days}}d {{hours}}h {{minutes}}m",
            distance_title: "Distancia recorrida",
            emissions_title: "CO2 de escape",
            emissions_value_g: "{{g}} g",
            emissions_value_kg: "{{kg}} kg",
            states_visited_title: "Estados visitados",
            cairns_discovered_title: "Cairns descubiertos",
            exploration_title: "Exploración"
        },
        compass: {
            north_east: "Noreste",
            east: "Este",
            south_east: "Sureste",
            south: "Sur",
            south_west: "Suroeste",
            west: "Oeste",
            north_west: "Noroeste",
            north: "Norte"
        },
        landing: {
            about_title: "Acerca de",
            start_title: "Iniciar",
            features_title: "Características",
            about_headline: "America: simulador de viaje en carretera en tu navegador",
            about_paragraph_1:
                "Safari, Chrome, Edge. Estos son portales a los rincones infinitos de la web.\n"
                + "America es tu portal a otro tipo de terreno extenso: las maravillas naturales\n"
                + "de los Estados Unidos, donde hay tanto que aprender, al ritmo que elijas.",
            about_paragraph_2:
                "Desde paisajes monumentales hasta momentos tranquilos al borde de la carretera,\n"
                + "diriges el viaje a través de una interfaz con ventanas estilo escritorio: mapa,\n"
                + "radio en vivo, artículos de enciclopedia, galería de fotos, métricas, diario y\n"
                + "más. Sin marcador, sin prisa: la serendipia y la atmósfera primero. Ábrelo en\n"
                + "un navegador moderno; nada que instalar.",
            about_paragraph_3:
            "Tu viaje puede seguir la autopista del Pacífico, recorrer la Ruta 66 por las"
                + "llanuras, cruzar las Rocosas hacia los parques nacionales o vagar por las"
                + "carreteras secundarias de Nueva Inglaterra. Cada parada revela la historia"
                + "local: qué ha visto este pueblo, cañón o mirador, qué suena en la radio y qué"
                + "tiempo hace ahora mismo. Es un simulador de viaje en carretera para explorar"
                + "Estados Unidos a tu propio ritmo, desde tu navegador, en cualquier dispositivo.",

            trips_title: "Explora por viaje",
            trips_list: [
                { label: "Viaje virtual por carretera", url: "/virtual-road-trip/" },
                { label: "Viaje por carretera por EE. UU.", url: "/us-road-trip/" },
                { label: "Viaje por los parques nacionales", url: "/national-parks-road-trip/" },
                { label: "Viaje por la Ruta 66", url: "/route-66-road-trip/" },
                { label: "Explora América", url: "/explore-america/" },
                { label: "Viaje por carretera a través de América", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "Ver anuncio",
            start_cta: "Iniciar viaje",
            start_cta_lead: "Sin instalación. Se ejecuta en tu navegador.",
            features_lede:
                "Una vez que comience tu viaje, configurarás el panel de control desde el\n"
                + "conjunto de herramientas de viaje en carretera de America. Cada ventana es una\n"
                + "manera diferente de experimentar el país. Desde la radio local hasta un\n"
                + "walkie-talkie con otros conductores, estás seguro de descubrir algo nuevo en\n"
                + "cada viaje.",
            features_list: [
                "Mapa con enrutamiento y exploración por todo EE. UU.",
                "Radio en streaming y artículos y fotos vinculados a lugares",
                "Diario, métricas, galería de fotos y enciclopedia",
                "Amigos, chat de voz y hitos compartidos en la carretera (cairns)",
                "Se ejecuta en el navegador en teléfono o escritorio; sin descarga",
            ],
            media_alt: "America Complete Edition: caja de software y CD",
            slideshow_alt: "Fotografía de paisajes de viaje en carretera del simulador America, imagen",
            og_title: "America: Simulador de viaje en carretera",
            og_description:
                "Explora las maravillas naturales de los Estados Unidos en un simulador de viaje en carretera con estilo de escritorio. Mapas, radio, diario y descubrimientos serendípicos, directamente en tu navegador.",
            twitter_description:
                "Explora las maravillas naturales de los Estados Unidos en un simulador de viaje en carretera con estilo de escritorio. Sin instalación.",
            meta_description:
                "Conduce por carreteras reales de EE. UU. y explora maravillas naturales en un simulador de viaje en carretera gratuito. Mapas, radio, fotos. Sin descarga.",
            jsonld_description:
                "America es un simulador de viaje en carretera en tu navegador: explora las maravillas naturales de EE. UU. a tu propio ritmo con mapas, radio, fotos y una interfaz estilo escritorio. Sin descarga; inicia tu viaje en línea.",
            jsonld_genre: ["Simulador de viaje en carretera", "Juego de exploración", "Juego de navegador"],
            page_title: "Simulador de viaje en carretera de EE. UU. | America",
            html_lang: "es",
            og_locale: "es_ES",
            og_locale_alternate: ["en_US", "fr_FR", "de_DE", "ru_RU", "ja_JP", "ko_KR", "zh_CN", "pt_BR"],
            og_image_alt: "Captura de pantalla del simulador de viaje en carretera de America",
            twitter_image_alt: "Captura de pantalla del simulador de viaje en carretera de America",
        },
    }
};
